import { render } from "./fullscreen.svg?vue&type=template&id=9fab7a5e"
const script = {}
script.render = render

export default script